import React, { createContext } from 'react'

const ThemeContext = React.createContext(["green", () => {}]);

export default ThemeContext;